namespace Matrix.Data {
    export interface SecurityOverrideNullRow {
        SecurityId?: number;
        SecurityCode?: boolean;
        DealParentCode?: boolean;
        Name?: boolean;
        SecurityTypeCode?: boolean;
        LocalCurrencyCode?: boolean;
        ExposureMultiplier?: boolean;
        AssociatedAccountCode?: boolean;
        Sedol?: boolean;
        RIC?: boolean;
        Isin?: boolean;
        Cusip?: boolean;
        Figi?: boolean;
        Ticker?: boolean;
        InternalSecurityCode?: boolean;
        Issuer?: boolean;
        CouponRate?: boolean;
        MaturityDate?: boolean;
        SpLtRating?: boolean;
        SpStRating?: boolean;
        MoodysLtRating?: boolean;
        MoodysStRating?: boolean;
        FitchLtRating?: boolean;
        FitchStRating?: boolean;
        InternalLtRating?: boolean;
        InternalStRating?: boolean;
        CountryOfIssueCode?: boolean;
        CountryOfRiskCode?: boolean;
        CurrencyOfRiskCode?: boolean;
        TradeDate?: boolean;
        EffectiveDate?: boolean;
        BrokerCode?: boolean;
        Strategy?: boolean;
        OptionStyle?: boolean;
        ExerciseStyle?: boolean;
        PutOrCall?: boolean;
        StrikePrice?: boolean;
        StrikeCurrency?: boolean;
        Premium?: boolean;
        PremiumCcy?: boolean;
        PayOrRec?: boolean;
        FixedOrFloat?: boolean;
        FloatIndex?: boolean;
        InflationIndexLag?: boolean;
        InterestTerm?: boolean;
        Spread?: boolean;
        AllIn?: boolean;
        InterestCcy?: boolean;
        PaymentFrequency?: boolean;
        PaymentBusDayConvention?: boolean;
        PaymentCalendar?: boolean;
        FirstPaymentDate?: boolean;
        DayCountBasis?: boolean;
        ResetFrequency?: boolean;
        ResetBusDayConvention?: boolean;
        ResetCalendar?: boolean;
        UnderlyerName?: boolean;
        UnderlyerCcy?: boolean;
        UnderlyerType?: boolean;
        ClearerReference?: boolean;
        RedCode?: boolean;
        CreditEvents?: boolean;
        Guarantor?: boolean;
        GicsSector?: boolean;
        GicsIndustryGroup?: boolean;
        GicsIndustry?: boolean;
        GicsSubIndustry?: boolean;
        BorrowerCode?: boolean;
        IssuerCode?: boolean;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace SecurityOverrideNullRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'CreatedBy';
        export const localTextPrefix = 'Data.SecurityOverrideNull';
        export const deletePermission = 'DataAdmin:SecurityOverride';
        export const insertPermission = 'DataAdmin:SecurityOverride';
        export const readPermission = 'Read:SecurityOverride';
        export const updatePermission = 'DataAdmin:SecurityOverride';

        export declare const enum Fields {
            SecurityId = "SecurityId",
            SecurityCode = "SecurityCode",
            DealParentCode = "DealParentCode",
            Name = "Name",
            SecurityTypeCode = "SecurityTypeCode",
            LocalCurrencyCode = "LocalCurrencyCode",
            ExposureMultiplier = "ExposureMultiplier",
            AssociatedAccountCode = "AssociatedAccountCode",
            Sedol = "Sedol",
            RIC = "RIC",
            Isin = "Isin",
            Cusip = "Cusip",
            Figi = "Figi",
            Ticker = "Ticker",
            InternalSecurityCode = "InternalSecurityCode",
            Issuer = "Issuer",
            CouponRate = "CouponRate",
            MaturityDate = "MaturityDate",
            SpLtRating = "SpLtRating",
            SpStRating = "SpStRating",
            MoodysLtRating = "MoodysLtRating",
            MoodysStRating = "MoodysStRating",
            FitchLtRating = "FitchLtRating",
            FitchStRating = "FitchStRating",
            InternalLtRating = "InternalLtRating",
            InternalStRating = "InternalStRating",
            CountryOfIssueCode = "CountryOfIssueCode",
            CountryOfRiskCode = "CountryOfRiskCode",
            CurrencyOfRiskCode = "CurrencyOfRiskCode",
            TradeDate = "TradeDate",
            EffectiveDate = "EffectiveDate",
            BrokerCode = "BrokerCode",
            Strategy = "Strategy",
            OptionStyle = "OptionStyle",
            ExerciseStyle = "ExerciseStyle",
            PutOrCall = "PutOrCall",
            StrikePrice = "StrikePrice",
            StrikeCurrency = "StrikeCurrency",
            Premium = "Premium",
            PremiumCcy = "PremiumCcy",
            PayOrRec = "PayOrRec",
            FixedOrFloat = "FixedOrFloat",
            FloatIndex = "FloatIndex",
            InflationIndexLag = "InflationIndexLag",
            InterestTerm = "InterestTerm",
            Spread = "Spread",
            AllIn = "AllIn",
            InterestCcy = "InterestCcy",
            PaymentFrequency = "PaymentFrequency",
            PaymentBusDayConvention = "PaymentBusDayConvention",
            PaymentCalendar = "PaymentCalendar",
            FirstPaymentDate = "FirstPaymentDate",
            DayCountBasis = "DayCountBasis",
            ResetFrequency = "ResetFrequency",
            ResetBusDayConvention = "ResetBusDayConvention",
            ResetCalendar = "ResetCalendar",
            UnderlyerName = "UnderlyerName",
            UnderlyerCcy = "UnderlyerCcy",
            UnderlyerType = "UnderlyerType",
            ClearerReference = "ClearerReference",
            RedCode = "RedCode",
            CreditEvents = "CreditEvents",
            Guarantor = "Guarantor",
            GicsSector = "GicsSector",
            GicsIndustryGroup = "GicsIndustryGroup",
            GicsIndustry = "GicsIndustry",
            GicsSubIndustry = "GicsSubIndustry",
            BorrowerCode = "BorrowerCode",
            IssuerCode = "IssuerCode",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
